<template>
  <div class="reportTable">
    <div class="report">
      <div class="title-label">F01.只查询本日预到的宾客表</div>
      <div class="title">
        <ul>
          <li>
            <span>打印日期:</span>
            <span>2020/12/25</span>
          </li>
          <li>
            <span>打印时间</span>
            <span>08:48:45</span>
          </li>
          <li>
            <span>酒店日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span>名门大酒店-</span>
            <span>常州店</span>
          </li>
          <li>
            <span>F01</span>
            <span>今日预到宾客表</span>
          </li>
          <li>
            <span>查询日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>管理员</span>
          </li>
          <li>
            <span>总页数:</span>
            <span>1页</span>
          </li>
          <li>
            <span></span>
            <span>第一页</span>
          </li>
        </ul>
      </div>
      <div class="form-content">
        <ul class="formTitle">
          <li>账号</li>
          <li>订单号</li>
          <li>姓名</li>
          <li>性别</li>
          <li>客房类型</li>
          <li>间数</li>
          <li>房间号</li>
          <li>房价</li>
          <li>预到时间</li>
          <li>预离时间</li>
          <li>保留时间</li>
          <li>电话</li>
          <li>备注</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="preArrivalList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in preArrivalList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>
      <div class="total">
        <div>
          <span>合计</span>
          <span>20条记录</span>
          <span>20间</span>
          <span>5044.00</span>
        </div>
      </div>
    </div>
    <div class="report">
      <div class="title-label">F03.查询本日已经登记宾客表</div>
      <div class="title">
        <ul>
          <li>
            <span>打印日期:</span>
            <span>2020/12/25</span>
          </li>
          <li>
            <span>打印时间</span>
            <span>08:48:45</span>
          </li>
          <li>
            <span>酒店日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span>名门大酒店-</span>
            <span>常州店</span>
          </li>
          <li>
            <span></span>
            <span>今日到店宾客报表</span>
          </li>
          <li>
            <span>查询日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>管理员</span>
          </li>
          <li>
            <span>总页数:</span>
            <span>1页</span>
          </li>
          <li>
            <span></span>
            <span>第一页</span>
          </li>
        </ul>
      </div>
      <div class="form-content">
        <ul class="formTitle">
          <li>账号</li>
          <li>订单号</li>
          <li>姓名</li>
          <li>性别</li>
          <li>称谓</li>
          <li>客房类型</li>
          <li>间数</li>
          <li>房间号</li>
          <li>房价</li>
          <li>抵店时间</li>
          <li>预离时间</li>
          <li>国籍</li>
          <li>操作员</li>
          <li>状态</li>
          <li>协议单位/备注</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="registeredList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in registeredList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>
      <div class="total">
        <div>
          <span>合计</span>
          <span>20条记录</span>
          <span>20间</span>
          <span>5044.00</span>
        </div>
      </div>
    </div>
    <div class="report">
      <div class="title-label">F05.今日在店宾客报表</div>
      <div class="title">
        <ul>
          <li>
            <span>打印日期:</span>
            <span>2020/12/25</span>
          </li>
          <li>
            <span>酒店日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul class="hotelTitle">
          <li>
            <span class="hotelName">名门大酒店-常州店</span>
          </li>
          <li>
            <span class="HotelList">F05.今日在店宾客报表</span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>管理员</span>
          </li>
          <li>
            <span>总页数:3</span>
            <span>页码:3</span>
          </li>
        </ul>
      </div>
      <div class="form-content">
        <ul class="inStoreGuestTitle">
          <li v-for="item in inStoreTitle" :key="item">{{ item }}</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="inStoreTitleList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in inStoreTitleList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>
      <div>
        <ul class="inStoreGuestTotal">
          <li>小计:</li>
          <li>楼层</li>
          <li>九楼</li>
          <li>客人总数</li>
          <li>4位</li>
          <li>散客4位</li>
          <li>客人总数</li>
          <li>团队成员:0位</li>
          <li style="width: 72em"></li>
        </ul>
      </div>
      <div>
        <ul class="inStoreGuestTotal">
          <li>合计</li>
          <li>20条记录</li>
          <li>20间</li>
          <li>5044.00</li>
          <li style="width: 120em"></li>
        </ul>
      </div>
    </div>
    <div class="report">
      <div class="title-label">F051同行报表</div>
      <div class="title">
        <ul>
          <li>
            <span>打印日期:</span>
            <span>2020/12/25</span>
          </li>
          <li>
            <span>打印时间</span>
            <span>08:48:45</span>
          </li>
          <li>
            <span>酒店日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span>名门大酒店-</span>
            <span>常州店</span>
          </li>
          <li>
            <span></span>
            <span>F051 今日在店同行宾客报表</span>
          </li>
          <li>
            <span>查询日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>管理员</span>
          </li>
          <li>
            <span>总页数:</span>
            <span>1页</span>
          </li>
          <li>
            <span></span>
            <span>第一页</span>
          </li>
        </ul>
      </div>
      <div class="form-content">
        <ul class="formTitle">
          <li>同行主账号</li>
          <li>预定号</li>
          <li>姓名</li>
          <li>抵店时间</li>
          <li>预离时间</li>
          <li>同行主房号</li>
          <li>国籍</li>
          <li>房型</li>
          <li>数量</li>
          <li>房价</li>
          <li>房间数/房号</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="registeredList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in registeredList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>
      <!-- <div class="total">
        <div>
          <span>合计</span>
          <span>20条记录</span>
          <span>20间</span>
          <span>5044.00</span>
        </div>
      </div> -->
    </div>
    <!-- F07 -->
    <div class="report">
      <div class="title-label">F07.今日离店</div>
      <div class="title">
        <ul>
          <li>
            <span>打印日期:</span>
            <span>2020/12/25</span>
          </li>
          <li>
            <span>打印时间</span>
            <span>08:48:45</span>
          </li>
          <li>
            <span>酒店日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span>名门大酒店-</span>
            <span>常州店</span>
          </li>
          <li>
            <span></span>
            <span>F07 今日已离店宾客报表</span>
          </li>
          <li>
            <span>查询日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>管理员</span>
          </li>
          <li>
            <span>总页数:</span>
            <span>1页</span>
          </li>
          <li>
            <span></span>
            <span>第一页</span>
          </li>
        </ul>
      </div>
      <div class="form-content">
        <ul class="formTitle">
          <li>账号</li>
          <li>姓名</li>
          <li>性别</li>
          <li>称谓</li>
          <li>客房类型</li>
          <li>间数</li>
          <li>房号</li>
          <li>房价</li>
          <li>消费合计</li>
          <li>抵店时间</li>
          <li>预离时间</li>
          <li>同行房号</li>
          <li>国籍</li>
          <li>证件种类</li>
          <li>备注</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="registeredList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in registeredList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>
      <div class="total">
        <div>
          <span>合计</span>
          <span>20条记录</span>
          <span>20间</span>
          <span>5044.00</span>
        </div>
      </div>
    </div>
    <!-- F09 -->
    <div class="report">
      <div class="title-label">F09.当日到店并且在当日离店的宾客报表</div>
      <div class="title">
        <ul>
          <li>
            <span>打印日期:</span>
            <span>2020/12/25</span>
          </li>
          <li>
            <span>打印时间</span>
            <span>08:48:45</span>
          </li>
          <li>
            <span>酒店日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span>名门大酒店-</span>
            <span>常州店</span>
          </li>
          <li>
            <span></span>
            <span>F07 今日已离店宾客报表</span>
          </li>
          <li>
            <span>查询日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>管理员</span>
          </li>
          <li>
            <span>总页数:</span>
            <span>1页</span>
          </li>
          <li>
            <span></span>
            <span>第一页</span>
          </li>
        </ul>
      </div>
      <div class="form-content">
        <ul class="formTitle">
          <li>账号</li>
          <li>姓名</li>
          <li>性别</li>
          <li>称谓</li>
          <li>客房类型</li>
          <li>间数</li>
          <li>房号</li>
          <li>房价</li>
          <li>抵店时间</li>
          <li>离店日期及时间</li>
          <li>国籍</li>
          <li>证件种类</li>
          <li>状态</li>
          <li>备注</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="registeredList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in registeredList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>
      <div class="total">
        <div>
          <span>合计</span>
          <span>20条记录</span>
          <span>20间</span>
          <span>5044.00</span>
        </div>
      </div>
    </div>
    <!-- F10 -->
    <div class="report">
      <div class="title-label">
        F10.用房类型的查询报表；查询可按筛选框查询类别：内用/免费/会员/长包/赠送/钟点/协议/VIP等
      </div>
      <div class="title">
        <ul>
          <li>
            <span>打印日期:</span>
            <span>2020/12/25</span>
          </li>
          <li>
            <span>打印时间</span>
            <span>08:48:45</span>
          </li>
          <li>
            <span>酒店日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span>名门大酒店-</span>
            <span>常州店</span>
          </li>
          <li>
            <span></span>
            <span>F07 今日已离店宾客报表</span>
          </li>
          <li>
            <span>查询日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>管理员</span>
          </li>
          <li>
            <span>总页数:</span>
            <span>1页</span>
          </li>
          <li>
            <span></span>
            <span>第一页</span>
          </li>
        </ul>
      </div>
      <div class="form-content">
        <ul class="formTitle">
          <li>账号</li>
          <li>姓名</li>
          <li>性别</li>
          <li>称谓</li>
          <li>客房类型</li>
          <li>间数</li>
          <li>房号</li>
          <li>房价</li>
          <li>抵店时间</li>
          <li>预离时间</li>
          <li>国籍</li>
          <li>证件种类</li>
          <li>备注</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="registeredList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in registeredList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>
    </div>
    <!-- F13 -->
    <div class="report">
      <div class="title-label">F13.今日即将离店报表</div>
      <div class="title">
        <ul>
          <li>
            <span>打印日期:</span>
            <span>2020/12/25</span>
          </li>
          <li>
            <span>打印时间</span>
            <span>08:48:45</span>
          </li>
          <li>
            <span>酒店日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span>名门大酒店-</span>
            <span>常州店</span>
          </li>
          <li>
            <span></span>
            <span>F13.今日预离宾客报表</span>
          </li>
          <li>
            <span>查询日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>管理员</span>
          </li>
          <li>
            <span>总页数:</span>
            <span>1页</span>
          </li>
          <li>
            <span></span>
            <span>第一页</span>
          </li>
        </ul>
      </div>
      <div class="form-content">
        <ul class="formTitle">
          <li>账号</li>
          <li>姓名</li>
          <li>性别</li>
          <li>称谓</li>
          <li>客房类型</li>
          <li>间数</li>
          <li>房号</li>
          <li>房价</li>
          <li>消费合计</li>
          <li>抵店时间</li>
          <li>离店时间</li>
          <li>同行房号</li>
          <li>国籍</li>
          <li>证件种类</li>
          <li>备注</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="registeredList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in registeredList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>
      <div class="total">
        <div>
          <span>合计</span>
          <span>20条记录</span>
          <span>20间</span>
          <span>5044.00</span>
        </div>
      </div>
    </div>
    <!-- F14 -->
    <div class="report">
      <div class="title-label">
        F14.房卡操作日志报表；操作类型包括：制卡、注销、挂失、赔偿、无卡退房等
      </div>
      <div class="title">
        <ul>
          <li>
            <span>打印日期:</span>
            <span>2020/12/25</span>
          </li>
          <li>
            <span>打印时间</span>
            <span>08:48:45</span>
          </li>
          <li>
            <span>酒店日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span>名门大酒店-</span>
            <span>常州店</span>
          </li>
          <li>
            <span></span>
            <span>F14.房卡操作报表</span>
          </li>
          <li>
            <span>查询日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>管理员</span>
          </li>
          <li>
            <span>总页数:</span>
            <span>1页</span>
          </li>
          <li>
            <span></span>
            <span>第一页</span>
          </li>
        </ul>
      </div>
      <div class="form-content">
        <ul class="formTitle">
          <li>房号</li>
          <li>生效时间</li>
          <li>失效时间</li>
          <li>操作时间</li>
          <li>酒店日期</li>
          <li>制卡人</li>
          <li>类型</li>
          <li>备注</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="registeredList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in registeredList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>
      <div class="total">
        <div>
          <span>合计</span>
          <span>20条记录</span>
          <span>20间</span>
          <span>5044.00</span>
        </div>
      </div>
    </div>
    <!-- F15 -->
    <div class="report">
      <div class="title-label">
        F15.房吧消费明细；可按照此布局内容进行筛选查询
      </div>
      <div class="title">
        <ul>
          <li>
            <span>打印日期:</span>
            <span>2020/12/25</span>
          </li>
          <li>
            <span>打印时间</span>
            <span>08:48:45</span>
          </li>
          <li>
            <span>酒店日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span>名门大酒店-</span>
            <span>常州店</span>
          </li>
          <li>
            <span></span>
            <span>F15.房吧消费清单</span>
          </li>
          <li>
            <span>查询日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>管理员</span>
          </li>
          <li>
            <span>总页数:</span>
            <span>1页</span>
          </li>
          <li>
            <span></span>
            <span>第一页</span>
          </li>
        </ul>
      </div>
      <div class="form-content">
        <ul class="formTitle">
          <li>账号</li>
          <li>房号</li>
          <li>账项</li>
          <li>单价</li>
          <li>数量</li>
          <li>金额</li>
          <li>班次</li>
          <li>操作时间</li>
          <li>操作员</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="registeredList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in registeredList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>
      <!-- <div class="total">
        <div>
          <span>合计</span>
          <span>20条记录</span>
          <span>20间</span>
          <span>5044.00</span>
        </div>
      </div> -->
    </div>
    <!-- F16 -->
    <div class="report">
      <div class="title-label">F16.未到宾客报表</div>
      <div class="title">
        <ul>
          <li>
            <span>打印日期:</span>
            <span>2020/12/25</span>
          </li>
          <li>
            <span>打印时间</span>
            <span>08:48:45</span>
          </li>
          <li>
            <span>酒店日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span>名门大酒店-</span>
            <span>常州店</span>
          </li>
          <li>
            <span></span>
            <span>未到宾客明细报表</span>
          </li>
          <li>
            <span>查询日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>管理员</span>
          </li>
          <li>
            <span>总页数:</span>
            <span>1页</span>
          </li>
          <li>
            <span></span>
            <span>第一页</span>
          </li>
        </ul>
      </div>
      <div class="form-content">
        <ul class="formTitle">
          <li>账号</li>
          <li>姓名</li>
          <li>性别</li>
          <li>称谓</li>
          <li>客房类型</li>
          <li>间数</li>
          <li>房间号</li>
          <li>房价</li>
          <li>抵店时间</li>
          <li>预离时间</li>
          <li>国籍</li>
          <li>证件种类</li>
          <li>备注</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="registeredList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in registeredList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>
      <!-- <div class="total">
        <div>
          <span>合计</span>
          <span>20条记录</span>
          <span>20间</span>
          <span>5044.00</span>
        </div>
      </div> -->
    </div>
    <!-- F19 -->
    <div class="report">
      <div class="title-label">F19.房价报表</div>
      <div class="title">
        <ul>
          <li>
            <span>打印日期:</span>
            <span>2020/12/25</span>
          </li>
          <li>
            <span>打印时间</span>
            <span>08:48:45</span>
          </li>
          <li>
            <span>酒店日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span>名门大酒店-</span>
            <span>常州店</span>
          </li>
          <li>
            <span></span>
            <span>F19 宾客房价报表</span>
          </li>
          <li>
            <span>查询日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>管理员</span>
          </li>
          <li>
            <span>总页数:</span>
            <span>1页</span>
          </li>
          <li>
            <span></span>
            <span>第一页</span>
          </li>
        </ul>
      </div>
      <div class="form-content">
        <ul class="formTitle">
          <li>账号</li>
          <li>姓名</li>
          <li>抵店时间</li>
          <li>天数</li>
          <li>状态</li>
          <li>宾客类型</li>
          <li>房间号</li>
          <li>定价</li>
          <li>折扣率</li>
          <li>类型</li>
          <li>登记人</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="registeredList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in registeredList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>
    </div>
    <!-- F251 -->
    <div class="report">
      <div class="title-label">
        F251.操作员开房统计；按操作员和用房类型进行筛选和统计
      </div>
      <div class="title">
        <ul>
          <li>
            <span>打印日期:</span>
            <span>2020/12/25</span>
          </li>
          <li>
            <span>打印时间</span>
            <span>08:48:45</span>
          </li>
          <li>
            <span>酒店日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span>名门大酒店-</span>
            <span>常州店</span>
          </li>
          <li>
            <span></span>
            <span>前台操作日志查询报表-登记</span>
          </li>
          <li>
            <span>查询日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>管理员</span>
          </li>
          <li>
            <span>总页数:</span>
            <span>1页</span>
          </li>
          <li>
            <span></span>
            <span>第一页</span>
          </li>
        </ul>
      </div>
      <div class="form-content">
        <ul class="formTitle">
          <li>账号</li>
          <li>到店</li>
          <li>离店</li>
          <li>姓名</li>
          <li>房型</li>
          <li>房号</li>
          <li>房价</li>
          <li>间夜</li>
          <li>用房类型</li>
          <li>操作员</li>
          <li>当时状态</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="registeredList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in registeredList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>
      <div class="total">
        <div>
          <span>合计</span>
          <span>20条记录</span>
          <span>20间</span>
          <span>5044.00</span>
        </div>
      </div>
    </div>
    <!-- F31 -->
    <div class="report">
      <div class="title-label">F31.日志查询</div>
      <div class="title">
        <ul>
          <li>
            <span>打印日期:</span>
            <span>2020/12/25</span>
          </li>
          <li>
            <span>打印时间</span>
            <span>08:48:45</span>
          </li>
          <li>
            <span>酒店日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span>名门大酒店-</span>
            <span>常州店</span>
          </li>
          <li>
            <span></span>
            <span>前台操作日志查询报表-登记</span>
          </li>
          <li>
            <span>查询日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>管理员</span>
          </li>
          <li>
            <span>总页数:</span>
            <span>1页</span>
          </li>
          <li>
            <span></span>
            <span>第一页</span>
          </li>
        </ul>
      </div>
      <div class="form-content">
        <ul class="formTitle">
          <li>房号</li>
          <li>账号</li>
          <li>姓名</li>
          <li>操作时间</li>
          <li>酒店时间</li>
          <li>原值</li>
          <li>新值</li>
          <li>操作员</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="registeredList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in registeredList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>
      <div class="total">
        <div>
          <span>合计</span>
          <span>20条记录</span>
          <span>20间</span>
          <span>5044.00</span>
        </div>
      </div>
    </div>
    <!-- F32 -->
    <div class="report">
      <div class="title-label">F32.取消报表</div>
      <div class="title">
        <ul>
          <li>
            <span>打印日期:</span>
            <span>2020/12/25</span>
          </li>
          <li>
            <span>打印时间</span>
            <span>08:48:45</span>
          </li>
          <li>
            <span>酒店日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul style="display: flex; flex-direction: column; align-items: center">
          <li>
            <span>名门大酒店-</span>
            <span>常州店</span>
          </li>
          <li>
            <span></span>
            <span>今日取消宾客报表</span>
          </li>
          <li>
            <span>查询日期</span>
            <span>2020年11月23日</span>
          </li>
        </ul>
        <ul
          style="display: flex; flex-direction: column; align-items: flex-end"
        >
          <li>
            <span>操作员:</span>
            <span>管理员</span>
          </li>
          <li>
            <span>总页数:</span>
            <span>1页</span>
          </li>
          <li>
            <span></span>
            <span>第一页</span>
          </li>
        </ul>
      </div>
      <div class="form-content">
        <ul class="formTitle">
          <li>账号</li>
          <li>姓名</li>
          <li>性别</li>
          <li>称谓</li>
          <li>客房类型</li>
          <li>间数</li>
          <li>房间号</li>
          <li>房价</li>
          <li>抵店时间</li>
          <li>预离时间</li>
          <li>国籍</li>
          <li>操作员</li>
          <li>状态</li>
          <li>协议单位/备注</li>
        </ul>
      </div>
      <div class="formContaniner">
        <transition-group name="registeredList" tag="p">
          <div
            class="PreArrivalItem"
            v-for="(item, index) in registeredList"
            :key="item.id"
          >
            <div>{{ index + 1 }}</div>
            <div>{{ item.description }}</div>
            <div>{{ item.disporder }}</div>
          </div>
        </transition-group>
      </div>
      <div class="total">
        <div>
          <span>合计</span>
          <span>20条记录</span>
          <span>20间</span>
          <span>5044.00</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 本日预到的宾客表
      preArrivalList: [],
      // 已经登记宾客表
      registeredList: [],
      // 今日在店宾客报表
      // inStoreTitle: [
      //   "账号",
      //   "姓名",
      //   "国籍",
      //   "性别",
      //   "称谓",
      //   "抵店时间",
      //   "预离时间",
      //   "客房类型",
      //   "房间号",
      //   "房价",
      //   "用房类型",
      //   "团队",
      //   "市场码",
      //   "证件号/地址/备注",
      // ],
      inStoreTitleList: [],
    };
  },
};
</script>

<style scoped>
.reportTable {
  height: 100%;
  overflow: scroll;
}
.title {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
  height: 62px;
}
.title > ul {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
ul li {
  list-style: none;
  font-size: 14px;
}
.title-label {
  font-size: 14px;
  margin-bottom: 20px;
}
.formTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-top: 1px solid #000;
  border-bottom: 1px solid #000;
  line-height: 25px;
  margin-bottom: 10px;
}
.formTitle > li {
  width: 8%;
  text-align: center;
}
.PreArrivalItem {
  width: 8%;
  text-align: center;
}
.total {
  font-size: 14px;
  font-weight: bold;
}
.total > div {
  padding-left: 220px;
}
.total > div > span {
  margin-right: 50px;
}
.hotelTitle {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 40%;
}
.hotelTitle > li {
  width: 100%;
}
.hotelName {
  width: 100%;
  display: inline-block;
  text-align: center;
  font-size: 30px;
  border-bottom: 1px solid #000;
}
.HotelList {
  font-size: 14px;
  width: 100%;
  display: inline-block;
  text-align: center;
  border-top: 1px solid #000;
}

.inStoreGuestTitle {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  /* border: 1px solid #000; */
  line-height: 25px;
  /* margin-bottom: 10px; */
}
.inStoreGuestTitle > li {
  border: 1px solid #000;
  width: 12em;
  text-align: center;
}
.inStoreGuestTotal {
  display: flex;
  flex-direction: row;
  line-height: 25px;
}
.inStoreGuestTotal > li {
  width: 12em;
  text-align: center;
  border: 1px solid #000;
}
.report {
  margin-bottom: 80px;
}
</style>